import React from 'react';
import { Modal } from 'antd';

interface CustomModalProps {
  open: boolean;
  onCancel: () => void;
  title?: string;
  icon?: React.ReactNode; // nhận icon từ props
  children?: React.ReactNode;
  footer?: React.ReactNode;
  width?: number;
}

const CustomModal: React.FC<CustomModalProps> = ({
  open,
  onCancel,
  title = '確認ダイアログ',
  icon,
  children,
  footer,
  width = 1200,
}) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      closable={true}
      centered
      width={width}
      className="confirm-modal"
    >
      <div className="confirm-modal-content">
        <div className="confirm-modal-header">
          {icon}
          <span className="confirm-modal-title">{title}</span>
        </div>
        <div className="p-6">{children}</div>
        {footer && <div className="confirm-modal-footer">{footer}</div>}
      </div>
    </Modal>
  );
};

export default CustomModal;

